import { makeApi, Zodios, type ZodiosOptions } from "@zodios/core";
import { z } from "zod";




  const OkResponseDto = z.object({ success: z.literal(true) });
  const GetGuestConsentsResponseDto = z.object({ guestId: z.string(), consents: z.array(z.object({ type: z.enum(["general-terms", "marketing", "member-marketing", "first-party", "process-and-store-id-documents"]) })), email: z.string().email(), firstName: z.string().optional(), lastName: z.string().optional() });
  const PostGuestConsentsRequestDto = z.object({ consents: z.array(z.object({ type: z.enum(["general-terms", "marketing", "member-marketing", "first-party", "process-and-store-id-documents"]) })), confirmationHost: z.string().optional(), shouldDelayConfirmation: z.boolean().optional(), preferredLanguage: z.string().optional(), firstName: z.string().optional(), lastName: z.string().optional() });
  const PostGuestConsentsResponseDto = z.object({ guestId: z.string(), consents: z.array(z.object({ type: z.enum(["general-terms", "marketing", "member-marketing", "first-party", "process-and-store-id-documents"]) })), email: z.string().email(), firstName: z.string().optional(), lastName: z.string().optional() });
  const ConfirmGuestConsentsResponseDto = z.object({ guestId: z.string() });
  const ErrorResponseDto = z.object({ success: z.literal(false), message: z.unknown().nullish() });
  const ConsentDto = z.object({ type: z.enum(["general-terms", "marketing", "member-marketing", "first-party", "process-and-store-id-documents"]) });

  export const schemas = {
    OkResponseDto,
    GetGuestConsentsResponseDto,
    PostGuestConsentsRequestDto,
    PostGuestConsentsResponseDto,
    ConfirmGuestConsentsResponseDto,
    ErrorResponseDto,
    ConsentDto,
  };
    export type OkResponseDto = z.infer<typeof OkResponseDto>;
    export type GetGuestConsentsResponseDto = z.infer<typeof GetGuestConsentsResponseDto>;
    export type PostGuestConsentsRequestDto = z.infer<typeof PostGuestConsentsRequestDto>;
    export type PostGuestConsentsResponseDto = z.infer<typeof PostGuestConsentsResponseDto>;
    export type ConfirmGuestConsentsResponseDto = z.infer<typeof ConfirmGuestConsentsResponseDto>;
    export type ErrorResponseDto = z.infer<typeof ErrorResponseDto>;
    export type ConsentDto = z.infer<typeof ConsentDto>;

const endpoints = makeApi([
    {
      method: "get",
      path: "/guests/v1/consents/:email",
        alias: "getGuestConsents",
      requestFormat: "json",
      parameters: [
          {
            name: "email",
            type: "Path",
            schema: z.string()
          },
      ],
    response: OkResponseDto.and(z.object({ data: GetGuestConsentsResponseDto })),
      errors: [
          {
              status: 404,
              description: `Guest not found`,
            schema: z.void()
          },
      ]
  },
    {
      method: "post",
      path: "/guests/v1/consents/:email",
        alias: "postGuestConsents",
      requestFormat: "json",
      parameters: [
          {
            name: "body",
            type: "Body",
            schema: PostGuestConsentsRequestDto
          },
          {
            name: "email",
            type: "Path",
            schema: z.string()
          },
      ],
    response: OkResponseDto.and(z.object({ data: PostGuestConsentsResponseDto })),
      errors: [
          {
              status: 400,
              description: `Invalid consents`,
            schema: z.void()
          },
      ]
  },
    {
      method: "post",
      path: "/guests/v1/consents/:email/confirm",
        alias: "confirmGuestConsents",
      requestFormat: "json",
      parameters: [
          {
            name: "email",
            type: "Path",
            schema: z.string()
          },
      ],
    response: OkResponseDto.and(z.object({ data: ConfirmGuestConsentsResponseDto })),
      errors: [
          {
              status: 400,
              description: `Invalid consents`,
            schema: z.void()
          },
          {
              status: 404,
              description: `Guest not found`,
            schema: z.void()
          },
      ]
  },
]);

export const createGuestApiClient = (baseUrl: string, options?: ZodiosOptions) => {
  return new Zodios(baseUrl, endpoints, options);
};
